/**
 * 响应 code
 */
export enum ResponseCode {
  Success = 200,
  /** 机器人过期 */
  RobotExpired = 450,
  /** 动能值不足 */
  Poweroff = 534,
  /** 模板过期 */
  TemplateExpired = 535,
}

export const BASE_OSS_URL = "https://actstatic.insnail.com/workflow";

export const DAMSELFISH_MANAGETMENT_TOKEN = "damselfish-admin-token";
